// extracted by mini-css-extract-plugin
module.exports = {"activityTitle":"GroupActivityItem_activityTitle__Hc5aL","activityContent":"GroupActivityItem_activityContent__3H-q_","activityIcon":"GroupActivityItem_activityIcon__CXDun"};